import { render } from "./liveStatus.vue?vue&type=template&id=298368ea&scoped=true"
import script from "./liveStatus.vue?vue&type=script&lang=js"
export * from "./liveStatus.vue?vue&type=script&lang=js"

import "./liveStatus.vue?vue&type=style&index=0&id=298368ea&scoped=true&lang=css"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298368ea"]])

export default __exports__